import React, { Component } from 'react';

import Css from './Form.scss';

import LetsConnectForm from '@components/LetsConnectForm/LetsConnectForm'

class Form extends Component {



    componentDidMount = () => {
        document.body.classList.add('modal-open');
    }

    componentWillUnmount = () => {
        document.body.classList.remove('modal-open');
    }


    render() {
        return (
            <div className={Css["form-container"] + ' p-3'} style={{height: this.props.areaHeight+'px'}}>
                <LetsConnectForm click={this.props.click}/>
            </div>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/components/LetsConnectMobile/Form/Form.js